// extracted by mini-css-extract-plugin
module.exports = {"box":"splash_box__2mqYN","bounce":"splash_bounce__1k2o-","bounce-1":"splash_bounce-1__3Chdz","backgroundScreen":"splash_backgroundScreen__1e1rA"};